var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isExecutive)?_c(_setup.ExecutivePopover,{attrs:{"value":_setup.entity}}):(_setup.isCompany)?_c(_setup.CompanyPopover,{attrs:{"value":_setup.entity}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }